import { commonShortNouns } from "./common-short-fields";
export const centersCenterJa = {
  title: "サービス入口とセンター状態",
  subtitle: "サービス入口レジストリに基づき、サービス入口、プラットフォームセンター、業務入口の現在の疎通状態を確認します。",
  infoMessage: "プラットフォーム管理と試験管理は分離されています。公開入口はサービス入口レジストリから派生し、プラットフォーム管理はプラットフォーム画面、試験管理は試験業務を扱います。",
  summaryDirectProbes: "バックエンド直接プローブ",
  summaryRestricted: "制限付き入口",
  tableTitle: "サービス入口とセンター一覧",
  tableSubtitle: "サービス入口、プラットフォームセンター、業務入口、互換ゲートウェイをレジストリ投影から一元確認します。",
  groupedTitle: "責務別に閲覧",
  groupedSubtitle: "プラットフォームの殻、センター、能力、基盤、業務入口を分けて確認してから詳細に入れます。",
  drawerTitle: "{name} ・ 詳細",
  detailBasicTitle: "基本状態",
  detailRuntimeTitle: "接続と依存",
  detailProbeTitle: "プローブ詳細",
  detailAccessRequirement: "アクセス要件",
  openConsole: "管理画面へ",
  footerHint: "プラットフォーム管理は試験管理の共通前端基盤を再利用しますが、問題・試験用紙・試験などの業務画面自体は再利用しません。",
  notices: {
    signalSemantics: "このページの状態はまずバックエンド集約プローブを読みます。直接プローブのない項目は、共有ヘルス、依存接続、ディレクトリ項目として明示されます。",
    backendProbe: "このページのヘルスは `/api/identity/platform-overview` が集約しています。最終確認: {value}",
  },
  cards: {
    coverageTitle: "信号カバレッジ",
    accessTitle: "アクセス範囲",
    catalogTitle: "カタログ構成",
    attentionTitle: "注目キュー",
    accessReasonTitle: "制限理由",
    attentionPreviewTitle: "現在の注目項目",
    attentionPreviewDescription: "オフライン、低下、未統合、制限付き、ディレクトリ項目を先に並べ、対応順を決めやすくします。",
  },
  metrics: {
    openableEntries: "直接開ける数",
    unstableEntries: "異常状態の入口",
    unintegratedEntries: "未完了の接続",
    restrictedEntries: "制限付き入口",
    directoryOnlyEntries: "ディレクトリ項目",
    restrictedReasonNone: "現在の権限",
    none: "なし",
    andMore: "+{count} 件",
  },
  signal: {
    directHealth: "バックエンド直接プローブ",
    sharedHealth: "共有ヘルス",
    providerDependency: "依存接続",
    directoryOnly: "ディレクトリ項目",
  },
  access: {
    available: "利用可能",
    restricted: "制限あり",
    externalSurface: "外部入口のため、プラットフォーム管理メニュー権限には制限されません",
    platformManagement: "プラットフォーム管理権限が必要です",
    platformDashboard: "プラットフォーム管理へのアクセス権限が必要です",
    identity: "統合認証センター権限が必要です",
    assets: "アセットセンター権限が必要です",
    environment: "環境センター権限が必要です",
    execution: "実行センター権限が必要です",
    intelligence: "インテリジェンスセンター権限が必要です",
    capabilityGraph: "能力グラフ権限が必要です",
    tacticsTechniques: "戦術技術ハブ権限が必要です",
    vulnerabilityLibrary: "脆弱性情報庫権限が必要です",
    businessReference: "業務参照センター権限が必要です",
    trafficLibrary: "トラフィックライブラリ権限が必要です",
  },
  filters: {
    scope: {
      all: "全範囲",
      platform: "プラットフォームのみ",
      business: "業務のみ",
      restricted: "制限のみ",
    },
    signal: {
      all: "全信号",
    },
    access: {
      all: "全アクセス",
      available: "利用可能",
      restricted: "制限あり",
    },
  },
  views: {
    list: "一覧",
    grouped: "グループ表示",
  },
  groups: {
    platformEntry: {
      title: "プラットフォーム入口",
      description: "管理、ポータル、アカウントなどの統一入口を担う殻レイヤです。",
    },
    platformCenter: {
      title: "プラットフォームセンター",
      description: "プラットフォーム制御面の主要な運用責務を直接担うセンターです。",
    },
    platformCapability: {
      title: "プラットフォーム能力",
      description: "プラットフォーム基盤上で提供される能力モジュールで、特定テーマの治理や分析に寄ります。",
    },
    platformInfrastructure: {
      title: "プラットフォーム基盤",
      description: "基盤接続性や互換エンドポイントを確認するための外部基盤面です。",
    },
    businessEntry: {
      title: "業務入口",
      description: "業務サービスや業務コンソールの入口で、レジストリ入口、到達性、依存関係の確認が中心です。",
    },
  },
  table: {
    name: "サービス / 入口",
    category: "分類",
    domain: "入口ドメイン",
    entryAddress: "入口 URL",
    status: commonShortNouns.status,
    latency: "遅延",
    signal: "信号源",
    access: "アクセス",
    mode: "モード",
    phase: "フェーズ",
    dependencies: "依存先",
    note: "説明",
    actions: "操作",
  },
} as const;
